import * as yup from 'yup';

import { ObjectTypeBase } from '../../../baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../../../properties/Property';
import { AllTypeContexts } from '../../../properties/TypeContextEnum';

import { Types } from '../../../properties/Types';
import { DateTimeDefinition } from '../../../properties/baseTypes/DateTime';
import { ImageDefinition } from '../../../properties/baseTypes/Image';
import { uuidTypeDefinition } from '../../../properties/baseTypes/UUID';
import { TYPE_GROUP_INTEGRATION } from '../../../properties/constants';
import { createShapeFromProperties } from '../../../properties/createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'String',
  },
  name: {
    type: 'String',
  },
  timezone: {
    type: 'String',
  },
  locale: {
    type: 'String',
  },
  logoOriginal: {
    type: 'String',
  },
  createdAt: {
    type: 'DateTime',
  },
};

export class ProxyClickCompanyType extends ObjectTypeBase {
  group = TYPE_GROUP_INTEGRATION;

  name = 'ProxyClickCompany';

  friendlyName = 'Proxyclick Company';

  superUserOnly = true;

  contexts = AllTypeContexts;

  get example() {
    return {
      _id: uuidTypeDefinition.example,
      name: 'Lane Technologies Inc.',
      timezone: 'America/Toronto',
      locale: 'en-US',
      logoOriginal: ImageDefinition.example,
      createdAt: DateTimeDefinition.example,
    };
  }

  get default(): any {
    return {
      _id: null,
      name: '',
      timezone: '',
      locale: '',
      logoOriginal: null,
      createdAt: null,
    };
  }

  buildSchema() {
    return yup.object().shape(createShapeFromProperties(properties)).nullable();
  }

  properties: any;
}

const definition = new ProxyClickCompanyType();

Types.addType(definition);
export { definition };
